import { render, staticRenderFns } from "./admin-application-show.vue?vue&type=template&id=245e12e0&scoped=true"
import script from "./admin-application-show.vue?vue&type=script&lang=js"
export * from "./admin-application-show.vue?vue&type=script&lang=js"
import style0 from "./admin-application-show.vue?vue&type=style&index=0&id=245e12e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e12e0",
  null
  
)

export default component.exports